import React from "react";
import { Col } from "reactstrap";

// Theme style
import "./lightTheme.scss";

//Redux
import { useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const UsernameConversation = ({ t }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  importDarkMode(mainTheme);

  return (
    <Col xs="12 clientInfoTitle">
      <h5 className="font-size-15 mt-2 text-wrap pl-0 d-flex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="13"
          viewBox="0 0 16 13"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="gray"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <path
              d="M9.12 1.44L14.4 1.44M9.12 4.32L14.4 4.32M11.52 7.2L14.4 7.2M11.52 10.08L14.4 10.08M8.64 11.28H0V9.004c0-.852.559-1.6 1.376-1.842.765-.227 1.794-.442 2.944-.442 1.131 0 2.166.219 2.94.447.819.242 1.38.99 1.38 1.844v2.269zM1.92 2.4c0-1.326 1.074-2.4 2.4-2.4 1.326 0 2.4 1.074 2.4 2.4 0 1.326-1.074 2.88-2.4 2.88-1.326 0-2.4-1.554-2.4-2.88z"
              transform="translate(1 1)"
            />
          </g>
        </svg>
        {t("General information")}
      </h5>
    </Col>
  );
};

export default withTranslation()(UsernameConversation);
